module.exports = __webpack_public_path__ + "img/img_image1.90c3b003.webp";